import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ContainerCard } from '@provider-portal/common/components/ContainerCard/ContainerCard';
import { Formik } from 'formik';
import { useInitialValues } from 'widgets/MenuEditor/hooks/useInitialValues';

import { NetworkRequestState } from '@bolteu/redux-session';

import { useAppIntl } from 'hooks/useAppIntl';
import { selectMenuUpdateRequestState, updateMenuAsyncAction } from 'rdx/menu';

import MenuContentFooter from './MenuContentFooter';
import MenuContentHeader from './MenuContentHeader';
import MenuItems from './MenuItems';

interface MenuContentProps {
  itemIds: number[];
  requestState: NetworkRequestState;
}

const validateForm = () => {
  const errors = {};
  return errors;
};

const MenuContent: React.FC<MenuContentProps> = ({ itemIds, requestState }) => {
  const dispatch = useDispatch();
  const { locale } = useAppIntl();
  const menuUpdateRequestState = useSelector(selectMenuUpdateRequestState);
  const [isSavingDisabled, setIsSavingDisabled] = useState<boolean>(
    requestState === NetworkRequestState.waiting,
  );
  const handleSubmitForm = useCallback(
    (values) => {
      setIsSavingDisabled(true);
      dispatch(updateMenuAsyncAction.request({ locale, items: values.items }));
    },
    [dispatch, locale],
  );

  useEffect(() => {
    switch (menuUpdateRequestState) {
      case NetworkRequestState.unset:
      case NetworkRequestState.success:
      case NetworkRequestState.failure:
        setIsSavingDisabled(false);
        break;
      case NetworkRequestState.waiting:
      default:
        setIsSavingDisabled(true);
        break;
    }
  }, [menuUpdateRequestState]);

  const initialValues = useInitialValues();

  if (!Object.keys(initialValues).length) {
    return null;
  }

  return (
    <ContainerCard>
      <Formik initialValues={initialValues} validate={validateForm} onSubmit={handleSubmitForm}>
        {({ handleSubmit, handleReset }) => (
          <>
            <MenuContentHeader
              onSave={handleSubmit}
              isSavingDisabled={isSavingDisabled}
              onReset={handleReset}
            />
            <MenuItems itemIds={itemIds} />
            <MenuContentFooter
              onSave={handleSubmit}
              isSavingDisabled={isSavingDisabled}
              onReset={handleReset}
            />
          </>
        )}
      </Formik>
    </ContainerCard>
  );
};

export default MenuContent;
